import Component from '../../../shared/component';

export default class AvatarBuilderOptionsNavigation extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$navigationRoot = this.$element.parents(
      '.menteeAvatarBuilderModal-list'
    );
    this.$optionsSections = this.$navigationRoot
      .parents('.modal-content')
      .find('.menteeAvatarBuilderModal-body-options');

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on(
      'click.AvatarBuilderOptionsNavigationButton',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$element.off(
      'click.AvatarBuilderOptionsNavigationButton',
      this.handleClick
    );
  }

  handleClick(event) {
    const $navigationItem = $(event.target);
    const $activeNavigationItem = this.getActiveNavigationItem();

    if (
      $navigationItem.data('category') ===
      $activeNavigationItem.data('category')
    )
      return;

    this.showOptionsSection($navigationItem);
    this.hideOptionSection($activeNavigationItem);
  }

  showOptionsSection(navigationItem) {
    const $section = this.getOptionsSection(navigationItem.data('category'));

    navigationItem.addClass('selected');
    $section.addClass('selected');
  }

  hideOptionSection(navigationItem) {
    const $section = this.getOptionsSection(navigationItem.data('category'));

    navigationItem.removeClass('selected');
    $section.removeClass('selected');
  }

  getActiveNavigationItem() {
    return this.$navigationRoot.find(
      '.menteeAvatarBuilderModal-body-category-nav-text.selected'
    );
  }

  getOptionsSection(categoryName) {
    return this.$optionsSections.find(
      `.menteeAvatarBuilderModal-body-options-group[data-category=${categoryName}]`
    );
  }
}
